// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "7fbb4ac7187282362439ba0de52fa25f30ac0517/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};